import { Component, Input } from "@angular/core";
import { DodoBaseButtonComponent } from "../dodo-base-button/dodo-base-button.component";

@Component({
    selector: "dodo-icon-raised-button",
    templateUrl: "./dodo-icon-raised-button.component.html",
    styleUrls: ["./dodo-icon-raised-button.component.scss"],
    standalone: false
})
export class DodoIconRaisedButtonComponent extends DodoBaseButtonComponent {
	@Input() busy = false;
	@Input() after = false;
	@Input() spinnerColor = "primary";
	@Input() iconImage: string;
	@Input() contentPadding = 20;

	constructor() {
		super();
	}
}
